import { getScreenNameAuthenticated } from "../../utils/auth/Auth-utils";
import * as FuncionesServices from "../../utils/funciones-services";

export const registrarFirma = async (firma) => {
    return FuncionesServices.procesarRespuestraCloud({
        url: process.env.REACT_APP_WS_POST_FIRMA,
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : getScreenNameAuthenticated(),
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID
        }),
        body: JSON.stringify(firma)
    })
}